import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiSmile3dSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g filter={`url(#${_uniqueId}filter0_i_8745_78)`} suppressHydrationWarning>
                    <path
                        d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5"
                        fill={`url(#${_uniqueId}paint0_radial_8745_78)`}
                        suppressHydrationWarning
                    />
                </g>
                <path
                    d="M4.352 9.723c.247-.273.608-.426.98-.426h5.332c.372 0 .733.153.98.426.26.286.39.705.252 1.141a3.2 3.2 0 0 1-.721 1.212c-.755.803-1.915 1.287-3.177 1.287s-2.422-.484-3.177-1.287a3.2 3.2 0 0 1-.721-1.212 1.16 1.16 0 0 1 .252-1.14"
                    fill="#9E7F10"
                />
                <path
                    d="M8 11c-1.523 0-3.333-.334-3.666-1.334L5 9.5h6l.667.166C11.334 10.667 9.524 11 8 11"
                    fill="white"
                />
                <path
                    d="M8 12c-1.108 0-2.424.167-2.666.667L6.5 13l1.5.5 1.5-.5 1.167-.333C10.424 12.167 9.108 12 8 12"
                    fill="white"
                />
                <path
                    d="M4.352 9.723c.247-.273.608-.426.98-.426h5.332c.372 0 .733.153.98.426.26.286.39.705.252 1.141a3.2 3.2 0 0 1-.721 1.212c-.755.803-1.915 1.287-3.177 1.287s-2.422-.484-3.177-1.287a3.2 3.2 0 0 1-.721-1.212 1.16 1.16 0 0 1 .252-1.14"
                    stroke="#79610C"
                    strokeWidth={0.667}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.665 5.065c-.461 0-.783.155-.988.4-.202.243-.278.56-.278.867s.076.623.278.866c.205.245.527.4.988.4.462 0 .784-.155.988-.4.202-.243.279-.56.279-.866 0-.307-.077-.624-.279-.866-.204-.246-.526-.4-.988-.4"
                    fill="#79610C"
                />
                <path
                    d="M10.33 5.065c-.46 0-.783.155-.987.4-.202.243-.279.56-.279.867s.077.623.279.866c.204.245.526.4.988.4s.783-.155.988-.4c.202-.243.278-.56.278-.866 0-.307-.076-.624-.278-.866-.205-.246-.527-.4-.988-.4"
                    fill="#79610C"
                />
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_78`}
                    x={0.5}
                    y={-2}
                    width={17.5}
                    height={17.5}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={2.5} dy={-2.5} />
                    <feGaussianBlur stdDeviation={2.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_78" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_78`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.211 3.3125) rotate(127.875) scale(13.3614)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiSmile3dSize16Glyph.displayName = 'EmojiSmile3dSize16Glyph';
